import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import history from '@utils/history'
import globalReducer from '@views/App/store/reducer'
import layout from '@reducers/basic/layout'
import user from '@reducers/basic/user'
import workbench from '@reducers/workbench'

const createReducer = (injectedReducers = {}) => {
  const rootReducer = combineReducers({
    global: globalReducer,
    layout,
    user,
    workbench,
    router: connectRouter(history),
    ...injectedReducers
  })
  return rootReducer
}

export default createReducer
